import React from "react";
import { Box, Dialog, TextField, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import socketService from "socket/SocketService";

const PushnotificationUpdateApp = ({ open, onClose }) => {
  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    body: Yup.string().required("Body is required"),
  });

  const formik = useFormik({
    initialValues: {
      title: "",
      body: "",
    },
    validationSchema,
    onSubmit: (values) => {
      socketService.emit("newversion", {
        title: values.title,
        desc: values.body,
      });

      toast.success("Push notification sent successfully!", {
        autoClose: 3000,
        position: toast.POSITION.TOP_CENTER,
      });

      onClose();
    },
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <IconButton
        edge="end"
        color="inherit"
        onClick={onClose}
        aria-label="close"
        sx={{
          position: "absolute",
          top: 10,
          right: 10,
        }}
      >
        <CloseIcon />
      </IconButton>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          width: "100%",
          padding: 4,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          backgroundColor: "#f7f9fc",
          borderRadius: 2,
        }}
      >
        <TextField
          id="title"
          name="title"
          label="Title"
          fullWidth
          value={formik.values.title}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.title && Boolean(formik.errors.title)}
          helperText={formik.touched.title && formik.errors.title}
        />

        <TextField
          id="body"
          name="body"
          label="Body"
          fullWidth
          multiline
          rows={6}
          value={formik.values.body}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.body && Boolean(formik.errors.body)}
          helperText={formik.touched.body && formik.errors.body}
        />

        <Button
          type="submit"
          variant="contained"
          fullWidth
          sx={{
            backgroundColor: "#1976d2",
            color: "#fff",
            fontWeight: "bold",
            padding: "12px 0",
            borderRadius: "8px",
            "&:hover": { backgroundColor: "#1565c0" },
          }}
        >
          SEND
        </Button>
      </Box>
    </Dialog>
  );
};

export default React.memo(PushnotificationUpdateApp);
